const mimeTypes: ReadonlyArray<string> = Object.freeze(['image/gif']);

export function isGifMimeType(mimeType: string | null | undefined): boolean {
    if (mimeType === null || mimeType === undefined) {
        return false;
    }
    return mimeTypes.includes(mimeType.toLowerCase());
}
